<div title="{{ 'TOOLTIP.HELP' | translate }}" class="main" fxLayout="column" (click)="openHelp()">
  <div class="center">
    <i class="bar-wide"></i>
    <i class="bar-narrow"></i>
  </div>
</div>

<div *ngIf="active" class="help-dialog-background" (click)="closeHelp()">
  <div class="help-dialog" (click)="eventNinja($event)">
    <div class="icon" [inlineSVG]="'assets/svg/close.svg'" (click)="closeHelp()"></div>
    <div class="title">
      {{ 'HELP.TITLE' | translate }}
    </div>
    <div fxLayout="column" class="content">
      <div fxLayout="row" class="steps">
        <app-helpstep *ngFor="let step of steps" [step]="step"></app-helpstep>
      </div>
    </div>
  </div>
</div>
